import { Routes } from '@angular/router';
import { HomeComponent } from './modules/home/home.component';
import { LayoutComponent } from './layout/layout.component';
import { noAuthGuard } from './auth/guards/no-auth.guard';
import { authGuard } from './auth/guards/auth.guard';
import { GolfDigestComponent } from './golf-digest/golf-digest.component';
import { GolfDigestLayoutComponent } from './layout/golf-digest-layout/golf-digest-layout.component';
import { GolfDigestLoginLayoutComponent } from './layout/golf-digest-login-layout/golf-digest-login-layout.component';
import { VoiceResponseLayoutComponent } from './layout/voice-response-layout/voice-response-layout.component';
import { VoiceHistoryComponent } from './modules/voice-response/voice-history/voice-history.component';
import { golfDigestAuthGuard } from './auth/guards/golf-digest-auth.guard';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { LivekitVoiceComponent } from './modules/voice-liv/voice-liv.component';
import { AuthComponent } from './modules/auth/auth.component';
import { OnCourseComponent } from './modules/golf-on-course/on-course/on-course.component';
import { InPlayComponent } from './modules/golf-on-course/in-play/in-play.component';
import { OnCourseLayoutComponent } from './modules/golf-on-course/on-course-layout/on-course-layout.component';
import { TodayInGolfComponent } from './modules/today-in-golf/today-in-golf.component';
import { ArticleDetailsComponent } from './modules/today-in-golf/article-details/article-details.component';

export const routes: Routes = [
  // {
  //   path: '',
  //   component: PublicLayoutComponent,
  //   children: [
  //     {
  //       path: '',
  //       component: HomeComponent,
  //       canActivate:[noAuthGuard]
  //     },
  //     // {
  //     //   path: 'answer',
  //     //   canActivate:[noAuthGuard],
  //     //   component: PublicShareComponent
  //     // } 
  //   ],
  // },
  // {
  //   path: '',
  //   loadChildren: () =>
  //     import('./modules/auth/auth.route').then((m) => m.AuthRoutes),
  //   canActivate: [noAuthGuard],
  // },
  {
    path: '',
    component: LayoutComponent,
    children: [
      // {
      //   path: 'answer',
      //   pathMatch: 'full',
      //   loadChildren: () =>
      //     import('./modules/answer/answer.route').then((m) => m.AnswerRoutes),
      // },
      // {
      //   path: 'home',
      //   pathMatch: 'full',
      //   canActivate: [authGuard],
      //   loadChildren: () =>
      //     import('./modules/chat/chat.route').then((m) => m.ROUTES)
      // },
      // First, a redirect route for /auth
      // {
      //   path: 'auth',
      //   redirectTo: 'auth/login',
      //   pathMatch: 'full'
      // },
      // Then, the actual /auth routes with children
      // {
      //   path: '',
      //   pathMatch: 'full',
      //   canActivate: [noAuthGuard],
      //   loadChildren: () =>
      //     import('./modules/home/home.routes').then((m) => m.ROUTES)
      // },
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./modules/landing/landing.component').then((m) => m.LandingComponent)
      },

      // {
      //   path: 'discover',
      //   loadChildren: () =>
      //     import('./modules/discover/discover.route').then((m) => m.ROUTES),
      //   canActivate: [authGuard],
      // },
      {
        path: 'discover',
        loadChildren: () =>
          import('./modules/leader-board/leader-board.route').then((m) => m.ROUTES)
      },
      {
        path: 'settings/user-settings',
        // pathMatch: 'full',
        loadChildren: () =>
          import('./modules/settings/settings.route').then(
            (m) => m.SettingsRoutes
          ),
        canActivate: [authGuard]
      },
      // {
      //   path: 'today-in-golf',
      //   pathMatch: 'full',
      //   canActivate: [authGuard],
      //   component: TodayInGolfComponent,
      // },
      // {
      //   path: 'today-in-golf/article-details',
      //   pathMatch: 'full',
      //   canActivate: [authGuard],
      //   component: ArticleDetailsComponent,
      // },
      // {

      //   path: 'voice-response/history',
      //   pathMatch: 'full',
      //   canActivate: [authGuard],
      //   component: VoiceHistoryComponent,
      // },
      // {
      //   path: 'map',
      //   loadChildren: () =>
      //     import('./modules/golf-on-course/on-course-map/on-course-map.route').then(
      //       (m) => m.OnCourseMapRoutes
      //     ),
      //   canActivate: [authGuard]
      // },
      {
        path: 'play-golf',
        pathMatch: 'full',
        component: OnCourseComponent,
        canActivate: [authGuard],
      },
      {
        path: 'tee-times',
        loadChildren: () =>
          import('./modules/tee-times/tee-times.routes').then(m => m.ROUTES),
        canActivate: [authGuard],
      },
      {
        path: 'video-wall',
        pathMatch: 'full',
        loadComponent: () =>
          import('./modules/video-wall/video-wall.component').then((m) => m.VideoWallComponent),
      },
      {
        path: 'video-wall/preview/:id',
        loadComponent: () =>
          import('./modules/video-wall/video-preview/video-preview.component').then((m) => m.VideoPreviewComponent),
      },
      {
        path: 'article',
        loadChildren: () =>
          import('./modules/article/article.routes').then((m) => m.ROUTES),
      },
    ],
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/auth/auth.route').then((m) => m.AuthRoutes),
        canActivate: [noAuthGuard],
      },
    ],
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/public/pubic.route').then((m) => m.PublicRoutes),
  },
  {
    path: 'embed',
    loadChildren: () =>
      import('./modules/leader-board/leader-board.route').then((m) => m.ROUTES)
  },
  // {
  //   path: 'voice-response',
  //   canActivate: [authGuard],
  //   pathMatch: 'full',
  //   component: VoiceResponseLayoutComponent,
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () =>
  //         import('./modules/voice-response/voice-response.route').then(
  //           (m) => m.VoiceRoutes
  //         ),
       
  //     },
  //   ],
  // },
  {
    path: 'in-play',
    canActivate: [authGuard],
    component: OnCourseLayoutComponent,
    children: [
      {
        path: ':id',
       component: InPlayComponent
      },
    ],
  },
  // {
  //   path: 'voice-response-new',
  //   canActivate: [authGuard],
  //   pathMatch: 'full',
  //   component: VoiceResponseLayoutComponent,
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () =>
  //         import('./modules/voice-chat/voice-chat.route').then(
  //           (m) => m.VoiceChatNewRoutes
  //         ),
  //     },
  //   ],
  // },
  // {
  // {
  //   path: 'voice-liv',
  //   canActivate: [authGuard],
  //   pathMatch: 'full',
  //   component: LivekitVoiceComponent,
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () =>
  //         import('./modules/voice-liv/voice-liv.route').then(
  //           (m) => m.VoiceLivRoutes
  //         ),
  //     },
  //   ],
  // },
  {
    path: 'concierge',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/voice-eleven-sdk/voice-eleven-sdk.route').then(
        (m) => m.VoiceElevenSdkRoutes
      ),
  },
  //   path: 'on-course/:id',
  //   component: VoiceResponseLayoutComponent,
  //   children:[{
  //     path:'',
  //     component: InPlayComponent
  //   }],
  // },
  // golf digest layout
  // {
  //   path: 'golf-digest',
  //   pathMatch: 'full',
  //   component: GolfDigestLayoutComponent,
  //   canActivate: [golfDigestAuthGuard],
  //   children: [
  //     {
  //       path: '',
  //       component: GolfDigestComponent,
  //     },
  //   ],
  // },
  // Golf Digest login layout
  {
    path: 'golf-digest',
    component: GolfDigestLoginLayoutComponent,
    children: [
      {
        path: '',
        component: AuthComponent,
        loadChildren: () =>
          import('./modules/auth/auth.route').then((m) => m.AuthRoutes),
        canActivate: [noAuthGuard],
      },
    ],
  },
  {
    path: 'error/404',
    component: PageNotFoundComponent
  },
  { path: '**', redirectTo: '' }
];
